import { Box, Icon, Image } from '@chakra-ui/react'
import { FaFileAlt } from 'react-icons/fa'
import PdfTileFallbackBySlug from '../../../app/investor-relations/[companySlug]/PdfTileFallbackBySlug'

interface StaticAttachmentPreviewProps {
  fileName: string
  fileType?: string
  thumbnailUrl?: string | null
  attachmentId: string
  companySlug: string
  section: string
  onOrientationDetected?: (isPortrait: boolean) => void
  [key: string]: unknown
}

export default function StaticAttachmentPreview({
  fileName,
  fileType,
  thumbnailUrl,
  attachmentId,
  companySlug,
  section,
  onOrientationDetected,
}: StaticAttachmentPreviewProps) {
  if (thumbnailUrl && fileType?.startsWith('image/')) {
    return (
      <Image
        src={thumbnailUrl}
        alt={`Preview of ${fileName}`}
        w="100%"
        h="100%"
        objectFit="cover"
        onLoad={(event) => {
          const image = event.currentTarget
          onOrientationDetected?.(image.naturalHeight > image.naturalWidth)
        }}
      />
    )
  }

  if (thumbnailUrl && fileType === 'application/pdf') {
    return (
      <PdfTileFallbackBySlug
        companySlug={companySlug}
        section={section}
        attachmentId={attachmentId}
        isPreview={false}
        organisationId=""
        sourceUrl={thumbnailUrl}
        onOrientationDetected={onOrientationDetected}
      />
    )
  }

  return (
    <Box
      w="100%"
      h="100%"
      bg="gray.200"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Icon as={FaFileAlt} boxSize={10} color="gray.500" />
    </Box>
  )
}
